import React from "react";
import LogoElements from "./LogoElements.tsx";
import { getCorrectMaxCount } from "../../util/logosBlock/getCorrectMaxCount.ts";
import { useBreakpoints } from "../../hooks/useBreakpoints.tsx";
const LogosBlock = ({ content }) => {
    if (!content) {
        return null;
    }
    const { logos } = content;
    const { isPhoneSmallWidth, isPhoneWidth, isTabletWidth, } = useBreakpoints();
    const transitionDelay = 0.6;
    const transitionOverlay = 2;
    const maxCount = getCorrectMaxCount(isPhoneSmallWidth, isPhoneWidth, isTabletWidth);
    const cycleLength = transitionDelay * 1000 * (maxCount + 1);
    const generateRandomOrder = (maxCount) => {
        const array = Array.from({ length: maxCount }, (_, index) => index);
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    };
    const randomOrder = generateRandomOrder(maxCount);
    return (React.createElement("div", { className: 'lg:px-0 px-4 relative flex gap-4 md:py-[60px] py-[60px]' }, randomOrder.map((number, rowIndex) => {
        let delay = number / 2 * transitionDelay + (Math.random() * transitionDelay / 3);
        return React.createElement(LogoElements, { key: rowIndex, items: logos, startIndex: number, delay: delay, cycleLength: cycleLength, transition: transitionDelay * transitionOverlay, columnCount: maxCount });
    })));
};
export default LogosBlock;
